import Vue from 'vue'
import Session from '@/session/Session.js'
import router from '@/router/index.js';

var api = function (entityClass) {
  this.entityClass = entityClass
}

api.getApiURL = () => {
  // return '/api/'
  return process.env.VUE_APP_API_BASEURL;
}

api.addErrorHandler = (r) => {

  Session.setError({})

  r.catch((error) => {
    error = error || {}
    window.console.log('error>', error, JSON.stringify(error))

    let httperr = ((error.response || {}).data ||{}).status

    if (+httperr === 401) {
      alert('Ha caducado la sesion. Por favor, vuelva a iniciar su solicitud.')
      Session.setAuthToken(null)

      router.push('/');

      return
    }

    // eval('debugger')
    let titulo = ''
    let descripcion = ''

    if(error.name && error.message) {
      titulo = error.name
      descripcion = error.message

      if(error.config) descripcion = descripcion + '. URL: ' + error.config.url
    }

    if(error.response) {
      if( error.response.data && error.response.data.error && error.response.data.error.id) {
        let e = error.response.data.error
        titulo = `Error ${e.id}`
        descripcion = `${e.description}`
      }

      if( error.response.data && error.response.data.error && error.response.data.status) {
        let e = error.response.data
        titulo = `HTTP/${e.status}`
        descripcion = `${error} - ${e.path}`
      }
    }

    if (error.data) {
      if (error.data.error && error.data.error.description) {
        descripcion = error.data.error.description
      } else if (error.data.message) {
        descripcion = error.data.message
      }
    }

    Session.setError({titulo, descripcion})


  })
  return r
}

var addGETParam = function (url, param) {
  url += (url.split('?')[1] ? '&' : '?') + param
  return url
}
/***
 *  Si el objeto incluye parametros de paginacion, se incluyen en la URL.
 **/
api.prototype.paged = function (url, params) {
  if (!params) return url

  if (params.pageNumber > -1) {
    url = addGETParam(url, 'pageNumber=' + params.pageNumber)
  }

  if (params.pageSize > -1) {
    url = addGETParam(url, 'pageSize=' + params.pageSize)
  }

  return url
}

api.prototype.GET = function (url) {
  let r = Vue.axios.get(api.getApiURL() + this.entityClass + url)

  return api.addErrorHandler(r)
}

api.prototype.DELETE = function (url) {
  let r = Vue.axios.delete(api.getApiURL() + this.entityClass + url)

  return api.addErrorHandler(r)
}

api.prototype.POST = function (url, objectToPost) {
  let r = Vue.axios.post(this.paged(api.getApiURL() + this.entityClass + url, objectToPost), objectToPost, { })

  return api.addErrorHandler(r)
}

api.prototype.POSTWithHeaders = function (url, objectToPost, headers) {
  let r = Vue.axios.post(api.getApiURL() + this.entityClass + url, objectToPost, { headers })

  return api.addErrorHandler(r)
}

api.prototype.PUT = function (url, objectToPost) {
  let r = Vue.axios.put(this.paged(api.getApiURL() + this.entityClass + url, objectToPost), objectToPost, { })

  return api.addErrorHandler(r)
}

api.prototype.findOne = function (id) {
  return this.GET('/' + id)
}

api.prototype.save = function (object) {
  return this.POST('', object, {})
}

api.prototype.remove = function (id) {
  return this.DELETE('/' + id)
}

export default api
